import type { ExternalTableSchema } from '@packages/table-builder';

export const esppPurchasesTable: ExternalTableSchema = {
  metadata: {
    title: 'ESPP Purchases',
    entity: 'Purchase',
  },

  dataSource: {
    endpoint: '/api/award/api/award/purchase/purchase-list',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      // Service (EsppPurchaseService) uses SearchKeyWord, not Filter
      SearchKeyWord: 'table.searchText',
      // Override table-builder default Filter param — purchase API uses SearchKeyWord only.
      Filter: '',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
    },
    filters: [
      {
        name: 'PurchaseStatusName',
        placeholder: 'Status',
        type: 'select',
        options: [
          { label: 'Draft', value: 'Draft' },
          { label: 'Published', value: 'Published' },
          { label: 'Cancelled', value: 'Cancelled' },
          { label: 'Rejected', value: 'Rejected' },
          { label: 'Pending', value: 'Pending' },
        ],
      },
      {
        name: 'PurchaseDate',
        placeholder: 'Purchase Date',
        type: 'date',
      },
    ],
  },

  columns: [
    { field: 'name', header: 'Name', type: 'text', sortable: true },
    {
      field: 'purchaseStatusName',
      header: 'Status',
      type: 'badge',
      width: 300,
      sortable: true,
      align: 'center',
      badge: {
        statusMap: {
          Draft: 'success',
          Published: 'success',
          Cancelled: 'error',
          Rejected: 'error',
          Pending: 'info',
        },
        defaultVariant: 'info',
      },
    },
    {
      field: 'purchaseDate',
      header: 'Purchase Date',
      type: 'date',
      width: 150,
      sortable: true,
    },
    {
      field: 'publishDate',
      header: 'Published Date',
      type: 'date',
      width: 200,
      sortable: true,
      visibility: 'picker',
    },
    {
      field: 'creationTime',
      header: 'Created Date',
      type: 'date',
      width: 200,
      sortable: true,
      align: 'center',
      visibility: 'picker',
    },
    {
      field: 'items',
      header: '#Items',
      type: 'text',
      width: 200,
      sortable: true,
      align: 'center',
      format: { commas: true, decimals: 4 },
      fields: { formatAsNumber: 'true' },
    },
    {
      field: 'noOfShares',
      header: '#Shares',
      type: 'text',
      width: 200,
      sortable: true,
      align: 'center',
      format: { commas: true, decimals: 4 },
      fields: { formatAsNumber: 'true' },
    },
  ],

  actions: {
    row: [
      { id: 'VIEW_PURCHASE_ESPP', label: 'View' },
      { id: 'PUBLISH_PURCHASE_ESPP', label: 'Publish Purchase' },
    ],
  },

  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    columnPreferences: { persistenceKey: 'Purchase', resizable: true, reorderable: true },
  },
};
